import { ReactNode } from 'react';
import { MailOutlined, WarningFilled, WarningOutlined } from '@ant-design/icons';
import { PresetColorType, PresetStatusColorType } from 'antd/lib/_util/colors';
import { LiteralUnion } from 'antd/lib/_util/type';
import MailWithWarningIcon from 'components/icons/MailWithWarningIcon';
import { EmailNotificationOverallStatuses, EmailNotificationProviderStatuses } from 'types/common';

type Response = {
    color: string;
    tooltip: string;
    tagColor: LiteralUnion<PresetColorType | PresetStatusColorType, string>;
    icon: ReactNode;
};

export const getEmailNotificationProps = (
    overallStatus: EmailNotificationOverallStatuses,
    providerStatus?: EmailNotificationProviderStatuses
): Response => {
    if (overallStatus === EmailNotificationOverallStatuses.NOT_SENT) {
        return {
            color: 'transparent',
            tooltip: '',
            tagColor: 'warning',
            icon: null,
        };
    }

    if (overallStatus === EmailNotificationOverallStatuses.SENT) {
        if (providerStatus === EmailNotificationProviderStatuses.COMPLAINT) {
            return {
                color: 'var(--warning-normal)',
                tagColor: 'warning',
                tooltip: "Email successfully send but may appear in recipient's spam or junk folder.",
                icon: <MailWithWarningIcon style={{ color: 'var(--warning-normal)', fontSize: 16 }} />,
            };
        }

        return {
            color: 'var(--success-normal)',
            tagColor: 'success',
            tooltip: 'Email successfully sent.',
            icon: <MailOutlined style={{ color: 'var(--success-normal)', fontSize: 16 }} />,
        };
    }

    if (overallStatus === EmailNotificationOverallStatuses.SENDING) {
        return {
            color: 'var(--processing-normal)',
            tagColor: 'processing',
            tooltip: 'Email sending is in progress.',
            icon: <MailOutlined style={{ color: 'var(--processing-normal)', fontSize: 16 }} />,
        };
    }

    if (overallStatus === EmailNotificationOverallStatuses.FAILED) {
        if (providerStatus === EmailNotificationProviderStatuses.BOUNCE) {
            return {
                tagColor: 'error',
                color: 'var(--error-normal)',
                tooltip: "Email sending failed due to a bounce from the recipient's mail server.",
                icon: <WarningOutlined style={{ color: 'var(--error-normal)', fontSize: 16 }} />,
            };
        }

        return {
            tagColor: 'error',
            color: 'var(--error-normal)',
            tooltip: 'Email sending failed.',
            icon: <WarningOutlined style={{ color: 'var(--error-normal)', fontSize: 16 }} />,
        };
    }

    return {
        color: 'var(--warning-normal)',
        tooltip: 'Unknown email notification data.',
        tagColor: 'warning',
        icon: <WarningFilled />,
    };
};
